/**
 * Настройки кита скелетона в одном месте. Цвет плашки — токены темы `SkeletonBase` /
 * `SkeletonHighlight` (класс `skeleton-block` в `src/index.css`), радиус — `--radius-card`.
 * Как собирать скелетон экрана и сверять его — `.claude/docs/skeleton-kit.md`.
 */

/**
 * Неразрывный пробел внутри плашки текста. Обычный пробел в пустом блоке схлопывается, плашка
 * теряет `line-height` и выходит ниже текста — на вкладке «Медиа» карточка пака была на 8px
 * ниже настоящей (IMGM-1491).
 */
export const SKELETON_NBSP = ' ';

/**
 * Хоткей панели «Сверка скелетона»: показать или скрыть. Сравнение по `KeyboardEvent.code` —
 * по физической клавише, поэтому сочетание работает в любой раскладке (с `key` в русской
 * раскладке пришла бы «ы»). `Alt+Shift` не годится: в Windows это переключение языка.
 */
export const SKELETON_PREVIEW_HOTKEY = {
  code: 'KeyS',
  ctrlKey: true,
  shiftKey: true,
  altKey: false,
  /** Подпись в панели. */
  label: 'Ctrl+Shift+S',
} as const;

/** Ключи `localStorage`: режим и видимость панели переживают F5. */
export const SKELETON_PREVIEW_STORAGE_KEY = 'imgame:dev:skeletonPreview';
export const SKELETON_PREVIEW_PANEL_STORAGE_KEY = 'imgame:dev:skeletonPreviewPanel';

/**
 * Прозрачность скелетона в режиме «Наложение». 50% — экран и плашки видны одинаково; сдвиг
 * читается как «двоение» края блока.
 */
export const SKELETON_OVERLAY_CLASS = 'opacity-50';
